<template>
  <v-row>
    <v-col sm="1" lg="2" class="hidden-xs-only" >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="regresar"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>

    <v-col cols="12" sm="10" lg="8">
      <DetailCard
        title="Detalles Saber"
        :loading="cardLoading"
      >
        <v-row justify="center">

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Saber
            </p>
            <template v-if="saber.saber != null">
              <p class="text-subtitle-1">
                {{ saber.saber }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrado
              </p>
            </template>
          </v-col>

          <v-col cols="12" sm="10" lg="8">
            <p class="text-h6 font-weight-bold">
              Descripción
            </p>
            <template v-if="saber.descripcion != null">
              <p class="text-subtitle-1">
                {{ saber.descripcion }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">
                No registrada
              </p>
            </template>
          </v-col>

        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from "../../../components/admin/DetailCard.vue";

export default {
  data: () => ({
    cardLoading: true,
  }),

  components: {
    DetailCard,
  },

  mounted() {
    this.$store.dispatch("obtenerSaberCampesenaId", {
      idCategoria: this.$route.params.idCategoria,
      idSaber: this.$route.params.idSaber,
    });

    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },

  computed: {
    saber() {
      return this.$store.getters.obtenerSaber;
    },
  },

  methods: {
    regresar() {
      this.$router.back();
    },
  },
};
</script>

